import { gql } from "@apollo/client";

const CLAIM_AND_ANSWER_MESSENGER_CALL = gql`
  mutation claimAndAnswerMessengerCall($callId: String!, $sdpOffer: String!) {
    claimAndAnswerMessengerCall(callId: $callId, sdpOffer: $sdpOffer) {
      success
      error
      sdpResponse
      sdpRenegotiation
      call {
        id
        callId
        pageId
        psid
        inboxId
        agentId
        status
        customerName
        customerPicture
      }
    }
  }
`;

export default CLAIM_AND_ANSWER_MESSENGER_CALL;
